import Sortable from 'sortablejs'
import $ from 'jquery'

import { useState } from 'hooks'
import { getFeedbackWorkflowsSelectors, getSortableRows } from 'selectors'
import { module } from 'constant'

type State = {
	sortableContainer?: HTMLElement
	sortableBody?: HTMLElement
	workflowsSelect?: HTMLSelectElement
}

const { selector } = module.creator.feedbackWorkflows

export const FeedbackWorkflows = () => {
	const { state, setState } = useState<State>()

	const initSortable = () => {
		const { workflowsSelect, sortableRowsHandle } = state

		if (sortableRowsHandle) {
			sortableRowsHandle.destroy()
			setState({ sortableRowsHandle: null })
		}

		if (!workflowsSelect || workflowsSelect.value.length === 0) return
		handleSortable()
	}

	const handleSortable = () => {
		const { workflowsSelect, sortableContainer, sortableBody } = state
		if (!workflowsSelect || !sortableContainer || !sortableBody) return

		const sortableRowsHandle = new Sortable(sortableBody, {
			onUpdate: () => {
				const sortableRows = getSortableRows()
				if (sortableRows.length === 0) return

				let priority = sortableRows.length
				let items = {}
				for (let i = 0; i < sortableRows.length; i++) {
					items[sortableRows[i].dataset.id] = priority
					priority--
				}

				// @ts-ignore
				$.nette.ajax({
					method: 'post',
					url: workflowsSelect.getAttribute(selector.reorderStatesHandle),
					data: { items },
				})
			},
		})

		setState({ sortableRowsHandle })
	}

	const init = () => {
		setState({ ...getFeedbackWorkflowsSelectors() })

		initSortable()
	}

	return {
		init,
	}
}
